// UAT link
// export const ApiLink="https://uatapi.pwrsteer.com/api/"
// live link
export const ApiLink="https://newdb.pwrsteer.com/api/"
  
// export const ApiLink ="https://ce52-2401-4900-7dc1-bd3f-d1f8-630c-5fd7-6f4f.ngrok-free.app/api/"